export const validateZipCode = Yup =>
	Yup.string().matches(
		/^[0-9a-z]+(([-\s]?)[0-9a-z]+)?$/i,
		"It should contains only letters and digits. Single space or '-' is allowed"
	);
